import React, { useMemo } from 'react'
import { usePageContext } from '../../../pages/context'
import RecommendedProduct from '../../../ecommerce/RecommendedProduct'
import { ProductDetailHeading } from '../ProductDetail'
import { BsArrowLeft, BsArrowRight } from 'react-icons/bs';

export default function RelatedProducts() {
    const { productDetailProduct: selectedProduct } = usePageContext();
    const pageLength = 4;
    const [page, setPage] = React.useState(0);

    const count = useMemo(() => {
        return selectedProduct?.relatedProducts?.length || 0;
    }, [selectedProduct?.relatedProducts]);

    const productsForPage = useMemo(() => {
        return selectedProduct?.relatedProducts.slice(0 + (page * pageLength), pageLength + (page * pageLength)) || [];
    }, [selectedProduct?.relatedProducts, page, pageLength]);

    const requiresPagination = useMemo(() => {
        return (count || 0) > pageLength;
    }, [count, pageLength]);

    const previousButtonDisabled = useMemo(() => {
        return page === 0;
    }, [page]);

    const nextButtonDisabled = useMemo(() => {
        return page === Math.ceil(count / pageLength) - 1;
    }, [page, count, pageLength]);

    const pages = useMemo(() => {
        return Math.ceil(count / pageLength);
    }, [count, pageLength]);

    if (count === 0 || !selectedProduct) { return <></>; }

    return (
        <section className="py-10">
            <div className="container max-w-screen-xl mx-auto px-3 text-center">
                <ProductDetailHeading>Other Products You May Like</ProductDetailHeading>
                <div className="text-center mb-10">
                    <p className="text-xl font-bold">See our full range of firewood and briquettes.</p>
                </div>
                <div className="flex flex-wrap -mx-3">
                    {productsForPage.map((prd) => (
                        <RecommendedProduct key={prd.id} product={prd} />
                    ))}
                </div>
                {requiresPagination &&
                    <div className="flex justify-center mt-6 gap-2 items-center">
                        <button
                            className={`p-4 rounded border border-primary ${previousButtonDisabled ? 'bg-white text-primary' : 'bg-primary text-white'}`}
                            onClick={() => setPage((prev) => (prev - 1))}
                            disabled={previousButtonDisabled}
                        >
                            <BsArrowLeft />
                        </button>
                        <div className="mx-6 flex justify-center gap-2 items-center">
                            {Array.from({ length: pages }, (_, i) => {
                                const isCurrentPage = page === i;
                                return <div key={i} className={`w-[20px] h-[20px] ${isCurrentPage ? "bg-[#a59ab4]" : ""} rounded-full flex items-center justify-center`} onClick={() => { setPage(i) }}>
                                    <div className={`${isCurrentPage ? "bg-secondary" : "bg-white"} w-[12px] h-[12px] rounded-full border border-secondary`}>
                                    </div>
                                </div>
                            })}
                        </div>
                        <button
                            className={`p-4 rounded border border-primary ${nextButtonDisabled ? 'bg-white text-primary' : 'bg-primary text-white'}`}
                            onClick={() => setPage((prev) => (prev + 1))}
                            disabled={nextButtonDisabled}
                        >
                            <BsArrowRight />
                        </button>
                    </div>}
            </div>
        </section>
    )
}
